<div class="progress-bar-wrap">
  <div class="progress-percentage">{{ progress }}% Complete</div>
  <div class="progress-bar-container">
    <div
      class="progress-bar-fill"
      [class.is-error]="isError"
      [style.width.%]="progress"
    ></div>
  </div>
  <span class="progress-text" *ngIf="text">{{ text }}</span>
</div>
